import NiceModal from '@ebay/nice-modal-react';
import { LinearProgress } from '@mui/material';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { SnackbarProvider } from 'notistack';
import { NuqsAdapter } from 'nuqs/adapters/react';
import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';

import { AuthProvider } from 'app/providers/AuthProvider';
import { ThemeProvider } from 'app/providers/ThemeProvider';
import { routeTree } from 'app/routeTree';

import { store } from 'shared/api';

const router = createRouter({
  routeTree,
  scrollRestoration: true,
  defaultHashScrollIntoView: { behavior: 'smooth' },
});

function App() {
  return (
    <ReduxProvider store={store}>
      <ThemeProvider>
        <AuthProvider>
          <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
            <NiceModal.Provider>
              <React.Suspense fallback={<LinearProgress />}>
                <NuqsAdapter>
                  <RouterProvider router={router} defaultPreload="intent" defaultPreloadStaleTime={0} />
                </NuqsAdapter>
              </React.Suspense>
            </NiceModal.Provider>
          </SnackbarProvider>
        </AuthProvider>
      </ThemeProvider>
    </ReduxProvider>
  );
}

export default App;
